"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumericPagination = void 0;
var AbstractPagination_1 = require("./AbstractPagination");
var ApiEndpoints_1 = require("../../Configurations/ApiEndpoints");
var TrackingTypes_1 = require("../../helpers/TrackingTypes");
var handle_url_1 = require("../../helpers/handle-url");
var tracker_1 = __importDefault(require("../../helpers/tracker"));
var HttpRequest_1 = require("../../Modules/HttpRequest");
var NumericPagination = /** @class */ (function (_super) {
    __extends(NumericPagination, _super);
    function NumericPagination(el, nextPage, category) {
        var _this = _super.call(this, el, nextPage, category) || this;
        _this.events = [
            {
                name: 'click',
                queries: ['.js-pagination-button', '.js-page-number'],
                callback: function (event) { return _this.requestNextPage(event); },
            },
        ];
        _this.url = ApiEndpoints_1.ApiEndpoints.SEARCH_EXPAND;
        _this.trackingCategory = TrackingTypes_1.TrackingData.PAGE_CP;
        _this.trackingAction = TrackingTypes_1.TrackingData.ACTION_CHANGE_PAGE;
        _this.sendRequestOnload();
        return _this;
    }
    NumericPagination.prototype.updatePaginationState = function (response) {
        // when filters are applied nextPage should be updated
        this.nextPage = response.nextPage || null;
        if (response.pagination) {
            this.el.innerHTML = response.pagination;
            this.attachEvents();
        }
        else if (response.pagination === null) {
            this.el.innerHTML = '';
        }
    };
    NumericPagination.prototype.getCurrentPage = function () {
        var urlParameters = (0, handle_url_1.getUrlParams)();
        return urlParameters.page || 1;
    };
    NumericPagination.prototype.sendRequestOnload = function () {
        var _this = this;
        if (this.isLoadingNextPage) {
            return;
        }
        this.nextPage = this.getCurrentPage();
        this.sendRequest()
            .then(function (response) {
            _this.url = ApiEndpoints_1.ApiEndpoints.SEARCH_PAGINATION;
            _this.handleResponse(response);
        })
            .catch(function (xhrResponse) { return HttpRequest_1.Xhr.logXhrPromiseRejection(xhrResponse, 'NumericPagination on sendRequestOnload'); });
    };
    NumericPagination.prototype.requestNextPage = function (event) {
        var _this = this;
        if (this.isLoadingNextPage) {
            return;
        }
        var dataPageNumber = event.currentTarget.getAttribute('data-page-number');
        if (!dataPageNumber) {
            throw new Error('No data defined');
        }
        var pageNumber = parseInt(dataPageNumber, 10);
        var urlParameters = (0, handle_url_1.getUrlParams)();
        this.url = ApiEndpoints_1.ApiEndpoints.SEARCH_PAGINATION;
        urlParameters.page = pageNumber;
        (0, handle_url_1.setUrl)((0, handle_url_1.objectToParams)(urlParameters));
        this.trackPageChangeEvent(pageNumber);
        this.nextPage = pageNumber;
        this.dispatchEvent(new CustomEvent('ajax:request:call'));
        this.sendRequest()
            .then(function (response) { return _this.handleResponse(response); })
            .catch(function (xhrResponse) {
            return HttpRequest_1.Xhr.logXhrPromiseRejection(xhrResponse, 'Error in NumericPagination on requestNextPage');
        });
    };
    NumericPagination.prototype.handleResponse = function (response) {
        if (response && response.data) {
            this.updatePaginationState(response);
            this.isLoadingNextPage = false;
            this.dispatchEvent(new CustomEvent('ajax:request:done'));
            this.dispatchEvent(new CustomEvent('products:loaded'), response);
        }
    };
    NumericPagination.prototype.trackPageChangeEvent = function (pageNumber) {
        tracker_1.default.track({
            category: this.trackingCategory,
            action: this.trackingAction,
            label: pageNumber,
        });
    };
    return NumericPagination;
}(AbstractPagination_1.AbstractPagination));
exports.NumericPagination = NumericPagination;
